import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getHardwareTypesByOrganization } from '../../../api/hardware';

const useHardwareTypeOrganization = (
  organizationId?: string,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) =>
  useQuery({
    queryKey: ['hardwareTypeByOrganization', organizationId],
    queryFn: () => getHardwareTypesByOrganization(organizationId),
    ...options,
  });

export default useHardwareTypeOrganization;
